"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
require("core-js/modules/es.symbol.js");
require("core-js/modules/es.symbol.description.js");
require("core-js/modules/es.symbol.iterator.js");
require("core-js/modules/es.symbol.to-primitive.js");
require("core-js/modules/es.array.filter.js");
require("core-js/modules/es.array.for-each.js");
require("core-js/modules/es.array.from.js");
require("core-js/modules/es.array.index-of.js");
require("core-js/modules/es.array.iterator.js");
require("core-js/modules/es.array.slice.js");
require("core-js/modules/es.date.to-primitive.js");
require("core-js/modules/es.function.name.js");
require("core-js/modules/es.number.constructor.js");
require("core-js/modules/es.object.assign.js");
require("core-js/modules/es.object.define-properties.js");
require("core-js/modules/es.object.define-property.js");
require("core-js/modules/es.object.get-own-property-descriptor.js");
require("core-js/modules/es.object.get-own-property-descriptors.js");
require("core-js/modules/es.object.keys.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.regexp.exec.js");
require("core-js/modules/es.regexp.test.js");
require("core-js/modules/es.regexp.to-string.js");
require("core-js/modules/es.string.iterator.js");
require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.for-each.js");
require("core-js/modules/web.dom-collections.iterator.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AccordionPanel = exports.AccordionListItem = exports.AccordionIcon = exports.AccordionButton = void 0;
var _react = _interopRequireWildcard(require("react"));
var _system = require("@chakra-ui/system");
var _ = require("..");
var _useObservabilitySafe = require("../../hooks/useObservabilitySafe");
var _utils = require("../../system/utils");
var _Icon = _interopRequireDefault(require("../Icon/Icon"));
var _excluded = ["analyticsName", "title", "children", "startExpanded", "justifyContent", "noPadding", "wrapText", "expandOnFocus", "panelId", "onOpen", "onToggle", "variant", "onMouseEnter", "maxHeight", "hasUnderline", "hasBorder", "paddingInline"],
  _excluded2 = ["isOpen", "panelId"],
  _excluded3 = ["panelId", "isOpen", "maxHeight", "onContentFocus"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function cov_22w7c5ye2p() {
  var path = "/__w/code/code/js/packages/bricks/src/core/List/AccordionListItem.tsx";
  var hash = "6dea93764ccbf2b724dcc6e448090b17b3790927";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/List/AccordionListItem.tsx",
    statementMap: {
      "0": {
        start: {
          line: 43,
          column: 33
        },
        end: {
          line: 134,
          column: 1
        }
      },
      "1": {
        start: {
          line: 72,
          column: 32
        },
        end: {
          line: 72,
          column: 64
        }
      },
      "2": {
        start: {
          line: 73,
          column: 34
        },
        end: {
          line: 73,
          column: 56
        }
      },
      "3": {
        start: {
          line: 74,
          column: 19
        },
        end: {
          line: 85,
          column: 6
        }
      },
      "4": {
        start: {
          line: 91,
          column: 24
        },
        end: {
          line: 104,
          column: 58
        }
      },
      "5": {
        start: {
          line: 92,
          column: 6
        },
        end: {
          line: 94,
          column: 7
        }
      },
      "6": {
        start: {
          line: 93,
          column: 8
        },
        end: {
          line: 93,
          column: 17
        }
      },
      "7": {
        start: {
          line: 95,
          column: 6
        },
        end: {
          line: 95,
          column: 29
        }
      },
      "8": {
        start: {
          line: 96,
          column: 6
        },
        end: {
          line: 101,
          column: 7
        }
      },
      "9": {
        start: {
          line: 97,
          column: 8
        },
        end: {
          line: 100,
          column: 11
        }
      },
      "10": {
        start: {
          line: 102,
          column: 6
        },
        end: {
          line: 102,
          column: 45
        }
      },
      "11": {
        start: {
          line: 102,
          column: 32
        },
        end: {
          line: 102,
          column: 43
        }
      },
      "12": {
        start: {
          line: 106,
          column: 4
        },
        end: {
          line: 132,
          column: 6
        }
      },
      "13": {
        start: {
          line: 122,
          column: 12
        },
        end: {
          line: 122,
          column: 56
        }
      },
      "14": {
        start: {
          line: 144,
          column: 63
        },
        end: {
          line: 163,
          column: 1
        }
      },
      "15": {
        start: {
          line: 145,
          column: 17
        },
        end: {
          line: 145,
          column: 64
        }
      },
      "16": {
        start: {
          line: 146,
          column: 2
        },
        end: {
          line: 162,
          column: 4
        }
      },
      "17": {
        start: {
          line: 166,
          column: 71
        },
        end: {
          line: 174,
          column: 1
        }
      },
      "18": {
        start: {
          line: 167,
          column: 17
        },
        end: {
          line: 167,
          column: 64
        }
      },
      "19": {
        start: {
          line: 169,
          column: 2
        },
        end: {
          line: 173,
          column: 4
        }
      },
      "20": {
        start: {
          line: 179,
          column: 4
        },
        end: {
          line: 197,
          column: 1
        }
      },
      "21": {
        start: {
          line: 180,
          column: 17
        },
        end: {
          line: 183,
          column: 4
        }
      },
      "22": {
        start: {
          line: 184,
          column: 2
        },
        end: {
          line: 196,
          column: 4
        }
      },
      "23": {
        start: {
          line: 193,
          column: 21
        },
        end: {
          line: 193,
          column: 61
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 44,
            column: 2
          },
          end: {
            line: 44,
            column: 3
          }
        },
        loc: {
          start: {
            line: 71,
            column: 7
          },
          end: {
            line: 133,
            column: 3
          }
        },
        line: 71
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 91,
            column: 36
          },
          end: {
            line: 91,
            column: 37
          }
        },
        loc: {
          start: {
            line: 91,
            column: 42
          },
          end: {
            line: 104,
            column: 5
          }
        },
        line: 91
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 102,
            column: 16
          },
          end: {
            line: 102,
            column: 17
          }
        },
        loc: {
          start: {
            line: 102,
            column: 32
          },
          end: {
            line: 102,
            column: 43
          }
        },
        line: 102
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 121,
            column: 26
          },
          end: {
            line: 121,
            column: 27
          }
        },
        loc: {
          start: {
            line: 121,
            column: 47
          },
          end: {
            line: 123,
            column: 11
          }
        },
        line: 121
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 144,
            column: 63
          },
          end: {
            line: 144,
            column: 64
          }
        },
        loc: {
          start: {
            line: 144,
            column: 98
          },
          end: {
            line: 163,
            column: 1
          }
        },
        line: 144
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 166,
            column: 71
          },
          end: {
            line: 166,
            column: 72
          }
        },
        loc: {
          start: {
            line: 166,
            column: 82
          },
          end: {
            line: 174,
            column: 1
          }
        },
        line: 166
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 179,
            column: 4
          },
          end: {
            line: 179,
            column: 5
          }
        },
        loc: {
          start: {
            line: 179,
            column: 66
          },
          end: {
            line: 197,
            column: 1
          }
        },
        line: 179
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 193,
            column: 15
          },
          end: {
            line: 193,
            column: 16
          }
        },
        loc: {
          start: {
            line: 193,
            column: 21
          },
          end: {
            line: 193,
            column: 61
          }
        },
        line: 193
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 49,
            column: 6
          },
          end: {
            line: 49,
            column: 27
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 49,
            column: 22
          },
          end: {
            line: 49,
            column: 27
          }
        }],
        line: 49
      },
      "1": {
        loc: {
          start: {
            line: 51,
            column: 6
          },
          end: {
            line: 51,
            column: 23
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 51,
            column: 18
          },
          end: {
            line: 51,
            column: 23
          }
        }],
        line: 51
      },
      "2": {
        loc: {
          start: {
            line: 52,
            column: 6
          },
          end: {
            line: 52,
            column: 21
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 52,
            column: 17
          },
          end: {
            line: 52,
            column: 21
          }
        }],
        line: 52
      },
      "3": {
        loc: {
          start: {
            line: 53,
            column: 6
          },
          end: {
            line: 53,
            column: 27
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 53,
            column: 22
          },
          end: {
            line: 53,
            column: 27
          }
        }],
        line: 53
      },
      "4": {
        loc: {
          start: {
            line: 76,
            column: 15
          },
          end: {
            line: 76,
            column: 32
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 76,
            column: 27
          },
          end: {
            line: 76,
            column: 28
          }
        }, {
          start: {
            line: 76,
            column: 31
          },
          end: {
            line: 76,
            column: 32
          }
        }],
        line: 76
      },
      "5": {
        loc: {
          start: {
            line: 80,
            column: 18
          },
          end: {
            line: 80,
            column: 48
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 80,
            column: 29
          },
          end: {
            line: 80,
            column: 37
          }
        }, {
          start: {
            line: 80,
            column: 40
          },
          end: {
            line: 80,
            column: 48
          }
        }],
        line: 80
      },
      "6": {
        loc: {
          start: {
            line: 92,
            column: 6
          },
          end: {
            line: 94,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 92,
            column: 6
          },
          end: {
            line: 94,
            column: 7
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 92
      },
      "7": {
        loc: {
          start: {
            line: 92,
            column: 10
          },
          end: {
            line: 92,
            column: 27
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 92,
            column: 10
          },
          end: {
            line: 92,
            column: 16
          }
        }, {
          start: {
            line: 92,
            column: 20
          },
          end: {
            line: 92,
            column: 27
          }
        }],
        line: 92
      },
      "8": {
        loc: {
          start: {
            line: 95,
            column: 6
          },
          end: {
            line: 95,
            column: 28
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 95,
            column: 6
          },
          end: {
            line: 95,
            column: 14
          }
        }, {
          start: {
            line: 95,
            column: 18
          },
          end: {
            line: 95,
            column: 28
          }
        }],
        line: 95
      },
      "9": {
        loc: {
          start: {
            line: 96,
            column: 6
          },
          end: {
            line: 101,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 96,
            column: 6
          },
          end: {
            line: 101,
            column: 7
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 96
      },
      "10": {
        loc: {
          start: {
            line: 114,
            column: 11
          },
          end: {
            line: 114,
            column: 88
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 114,
            column: 39
          },
          end: {
            line: 114,
            column: 80
          }
        }, {
          start: {
            line: 114,
            column: 83
          },
          end: {
            line: 114,
            column: 88
          }
        }],
        line: 114
      },
      "11": {
        loc: {
          start: {
            line: 122,
            column: 12
          },
          end: {
            line: 122,
            column: 55
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 122,
            column: 12
          },
          end: {
            line: 122,
            column: 25
          }
        }, {
          start: {
            line: 122,
            column: 29
          },
          end: {
            line: 122,
            column: 36
          }
        }, {
          start: {
            line: 122,
            column: 40
          },
          end: {
            line: 122,
            column: 55
          }
        }],
        line: 122
      },
      "12": {
        loc: {
          start: {
            line: 125,
            column: 11
          },
          end: {
            line: 129,
            column: 11
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 126,
            column: 12
          },
          end: {
            line: 126,
            column: 59
          }
        }, {
          start: {
            line: 128,
            column: 12
          },
          end: {
            line: 128,
            column: 20
          }
        }],
        line: 125
      },
      "13": {
        loc: {
          start: {
            line: 193,
            column: 21
          },
          end: {
            line: 193,
            column: 61
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 193,
            column: 21
          },
          end: {
            line: 193,
            column: 35
          }
        }, {
          start: {
            line: 193,
            column: 39
          },
          end: {
            line: 193,
            column: 61
          }
        }],
        line: 193
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0
    },
    b: {
      "0": [0],
      "1": [0],
      "2": [0],
      "3": [0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0, 0],
      "10": [0, 0],
      "11": [0, 0, 0],
      "12": [0, 0],
      "13": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "6dea93764ccbf2b724dcc6e448090b17b3790927"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_22w7c5ye2p = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_22w7c5ye2p();
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
/**
 * Accordion component that has the ability to open for additional info or close for less info. This component is used by AccordionList which stacks several Accordions together
 * If you are in bundle sensitive application (example: Cosmos) that uses Selective Spritesheet you must import - ChevronDown16 to get the chevron to appear
 */
var AccordionListItem = exports.AccordionListItem = (cov_22w7c5ye2p().s[0]++, (0, _system.forwardRef)(function (_ref, ref) {
  var analyticsName = _ref.analyticsName,
    title = _ref.title,
    children = _ref.children,
    _ref$startExpanded = _ref.startExpanded,
    startExpanded = _ref$startExpanded === void 0 ? (cov_22w7c5ye2p().b[0][0]++, false) : _ref$startExpanded,
    justifyContent = _ref.justifyContent,
    _ref$noPadding = _ref.noPadding,
    noPadding = _ref$noPadding === void 0 ? (cov_22w7c5ye2p().b[1][0]++, false) : _ref$noPadding,
    _ref$wrapText = _ref.wrapText,
    wrapText = _ref$wrapText === void 0 ? (cov_22w7c5ye2p().b[2][0]++, true) : _ref$wrapText,
    _ref$expandOnFocus = _ref.expandOnFocus,
    expandOnFocus = _ref$expandOnFocus === void 0 ? (cov_22w7c5ye2p().b[3][0]++, false) : _ref$expandOnFocus,
    panelId = _ref.panelId,
    onOpen = _ref.onOpen,
    onToggle = _ref.onToggle,
    variant = _ref.variant,
    onMouseEnter = _ref.onMouseEnter,
    maxHeight = _ref.maxHeight,
    hasUnderline = _ref.hasUnderline,
    hasBorder = _ref.hasBorder,
    paddingInline = _ref.paddingInline,
    props = _objectWithoutProperties(_ref, _excluded);
  cov_22w7c5ye2p().f[0]++;
  var _ref2 = (cov_22w7c5ye2p().s[1]++, (0, _react.useState)(startExpanded)),
    _ref3 = _slicedToArray(_ref2, 2),
    isOpen = _ref3[0],
    setIsOpen = _ref3[1];
  var _ref4 = (cov_22w7c5ye2p().s[2]++, (0, _useObservabilitySafe.useObservabilitySafe)()),
    trackJourneyEvent = _ref4.trackJourneyEvent;
  var styles = (cov_22w7c5ye2p().s[3]++, (0, _utils.useMultiStyleConfig)('AccordionListItem', _objectSpread({
    variant: variant,
    padding: noPadding ? (cov_22w7c5ye2p().b[4][0]++, 0) : (cov_22w7c5ye2p().b[4][1]++, 7),
    paddingInline: paddingInline,
    justifyContent: justifyContent,
    isOpen: isOpen,
    whiteSpace: wrapText ? (cov_22w7c5ye2p().b[5][0]++, 'normal') : (cov_22w7c5ye2p().b[5][1]++, 'nowrap'),
    maxHeight: maxHeight,
    hasBorder: hasBorder,
    hasUnderline: hasUnderline
  }, props)));
  /**
   * Handles opening the accordion when button is clicked
   * Calls the onOpen callback (if provided) when we're opening the accordion
   * Calls the onToggle callback (if provided) when we're opening and closing the accordion
   */
  var handleClick = (cov_22w7c5ye2p().s[4]++, (0, _react.useCallback)(function () {
    cov_22w7c5ye2p().f[1]++;
    cov_22w7c5ye2p().s[5]++;
    if ((cov_22w7c5ye2p().b[7][0]++, onOpen) && (cov_22w7c5ye2p().b[7][1]++, !isOpen)) {
      cov_22w7c5ye2p().b[6][0]++;
      cov_22w7c5ye2p().s[6]++;
      onOpen();
    } else {
      cov_22w7c5ye2p().b[6][1]++;
    }
    cov_22w7c5ye2p().s[7]++;
    (cov_22w7c5ye2p().b[8][0]++, onToggle) && (cov_22w7c5ye2p().b[8][1]++, onToggle());
    cov_22w7c5ye2p().s[8]++;
    if (analyticsName) {
      cov_22w7c5ye2p().b[9][0]++;
      cov_22w7c5ye2p().s[9]++;
      trackJourneyEvent('platform', 'accordionClickEvent', {
        targetName: analyticsName,
        accordionName: panelId
      });
    } else {
      cov_22w7c5ye2p().b[9][1]++;
    }
    cov_22w7c5ye2p().s[10]++;
    setIsOpen(function (prevIsOpen) {
      cov_22w7c5ye2p().f[2]++;
      cov_22w7c5ye2p().s[11]++;
      return !prevIsOpen;
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [onOpen, isOpen, onToggle, analyticsName, panelId]));
  cov_22w7c5ye2p().s[12]++;
  return /*#__PURE__*/_react["default"].createElement(_.ListItem, {
    __css: styles.listItem,
    "data-testid": "accordion-list-item",
    ref: ref
  }, /*#__PURE__*/_react["default"].createElement(AccordionButton, {
    isOpen: isOpen,
    panelId: panelId,
    justifyContent: justifyContent,
    onClick: handleClick
  }, typeof title === 'string' ? (cov_22w7c5ye2p().b[10][0]++, /*#__PURE__*/_react["default"].createElement(_.Text, {
    __css: styles.title
  }, title)) : (cov_22w7c5ye2p().b[10][1]++, title), /*#__PURE__*/_react["default"].createElement(AccordionIcon, {
    isOpen: isOpen,
    justifyContent: justifyContent
  })), /*#__PURE__*/_react["default"].createElement(AccordionPanel, {
    isOpen: isOpen,
    panelId: panelId,
    maxHeight: maxHeight,
    onContentFocus: function onContentFocus(isOpen) {
      cov_22w7c5ye2p().f[3]++;
      cov_22w7c5ye2p().s[13]++;
      (cov_22w7c5ye2p().b[11][0]++, expandOnFocus) && (cov_22w7c5ye2p().b[11][1]++, !isOpen) && (cov_22w7c5ye2p().b[11][2]++, setIsOpen(true));
    }
  }, typeof children === 'string' ? (cov_22w7c5ye2p().b[12][0]++, /*#__PURE__*/_react["default"].createElement(_.Text, {
    __css: styles.bodyText
  }, children)) : (cov_22w7c5ye2p().b[12][1]++, children)));
}));
/** Accordion button that handles if the accordion is open or close */
cov_22w7c5ye2p().s[14]++;
var AccordionButton = exports.AccordionButton = function AccordionButton(_ref5) {
  var isOpen = _ref5.isOpen,
    panelId = _ref5.panelId,
    props = _objectWithoutProperties(_ref5, _excluded2);
  cov_22w7c5ye2p().f[4]++;
  var styles = (cov_22w7c5ye2p().s[15]++, (0, _utils.useMultiStyleConfig)('AccordionListItem', props));
  cov_22w7c5ye2p().s[16]++;
  return /*#__PURE__*/_react["default"].createElement(_.Button, _extends({
    variant: "ghost",
    __css: styles.button,
    "data-testid": "".concat(panelId, "-accordion-button")
    // We already track accordion hover/click events so we do not need duplicative tracking through Button
    ,
    analyticsName: ""
    // Blank aria-label because the question should be descriptive enough
    ,
    "aria-label": null
    // accordion controls value is equal the ID of the tag that wraps the expanded content
    ,
    "aria-controls": panelId
    // set on an element to indicate if a control is expanded or collapsed
    // https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Attributes/aria-expanded
    ,
    "aria-expanded": isOpen
  }, props));
};

/** Chevron icon used inside Accordion Button that users can click to open or close accordion */
cov_22w7c5ye2p().s[17]++;
var AccordionIcon = exports.AccordionIcon = function AccordionIcon(props) {
  cov_22w7c5ye2p().f[5]++;
  var styles = (cov_22w7c5ye2p().s[18]++, (0, _utils.useMultiStyleConfig)('AccordionListItem', props));
  cov_22w7c5ye2p().s[19]++;
  return /*#__PURE__*/_react["default"].createElement(_.Flex, {
    __css: styles.iconContainer
  }, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
    name: "chevron-down",
    color: "neutrals100",
    size: 16
  }));
};

/** TODO: Panel is visable when isOpen is true */
cov_22w7c5ye2p().s[20]++;
var AccordionPanel = exports.AccordionPanel = function AccordionPanel(_ref6) {
  var panelId = _ref6.panelId,
    isOpen = _ref6.isOpen,
    maxHeight = _ref6.maxHeight,
    onContentFocus = _ref6.onContentFocus,
    props = _objectWithoutProperties(_ref6, _excluded3);
  cov_22w7c5ye2p().f[6]++;
  var styles = (cov_22w7c5ye2p().s[21]++, (0, _utils.useMultiStyleConfig)('AccordionListItem', {
    isOpen: isOpen,
    maxHeight: maxHeight
  }));
  cov_22w7c5ye2p().s[22]++;
  return (
    /*#__PURE__*/
    // TODO(@cplat-fe): Fix this a11y violation
    // eslint-disable-next-line jsx-a11y/no-static-element-interactions
    _react["default"].createElement(_.Box, _extends({
      __css: styles.panel,
      "data-testid": "accordion-panel"
      // Hide from screen-readers while closed
      ,
      "aria-hidden": !isOpen,
      id: panelId,
      onFocus: function onFocus() {
        cov_22w7c5ye2p().f[7]++;
        cov_22w7c5ye2p().s[23]++;
        return (cov_22w7c5ye2p().b[13][0]++, onContentFocus) && (cov_22w7c5ye2p().b[13][1]++, onContentFocus(isOpen));
      }
    }, props))
  );
};